import { checkAuthStatus, loginUser, logoutUser } from "../thunks/auth-thunks";

// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
    userEfficiency: null,
    status: "loading", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    // Synchronous reducers if needed
    setBasicAuth: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login cases
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.isAuthenticated = true;
        state.user = action.payload;
        state.userEfficiency = action.payload.consumption_factor;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Logout cases
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.status = "idle";
        state.error = null;
        state.userEfficiency = null;
      })

      // Check auth status cases
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.user = action.payload;
        state.userEfficiency = action.payload.consumption_factor;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(checkAuthStatus.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(checkAuthStatus.rejected, (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.status = "idle";
        state.error = null;
        state.userEfficiency = null; // Add this line
      });
  },
});

// Selector functions
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
export const selectUserEfficiency = (state) => state.auth.userEfficiency;

export const { setBasicAuth } = authSlice.actions;

export default authSlice.reducer;

// Export the thunks
export { loginUser, logoutUser, checkAuthStatus };
